import { ToastCustom } from "@components";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";
import {
	downloadInfractionAttachment,
	downloadInfractionAttachments,
} from "../services/infractions.service";

type DownloadInfractionAttachmentVariables =
	| string
	| number
	| {
			infractionId: string | number;
			attachmentId: string | number;
	  };

function resolveDownload(
	variables: DownloadInfractionAttachmentVariables
): Promise<void> {
	if (typeof variables === "object") {
		return downloadInfractionAttachment(
			Number(variables.infractionId),
			Number(variables.attachmentId)
		);
	}

	return downloadInfractionAttachments(Number(variables));
}

function getErrorMessage(error: unknown): string {
	if (error instanceof AxiosError) {
		const errorData = error.response?.data as
			| { error?: { detail?: string; errors?: string[] } }
			| undefined;
		const apiMessage =
			errorData?.error?.errors?.[0] ?? errorData?.error?.detail;

		if (apiMessage) {
			return apiMessage;
		}
	}

	if (error instanceof Error) {
		return error.message;
	}

	return "Não foi possível baixar o anexo.";
}

export function useDownloadInfractionAttachment() {
	return useMutation({
		mutationKey: ["infractions", "download-attachment"],
		mutationFn: (variables: DownloadInfractionAttachmentVariables) =>
			resolveDownload(variables),
		onSuccess: () => {
			toast(
				ToastCustom({
					description: "O download foi iniciado.",
					title: "Download iniciado",
					variant: "success",
				})
			);
		},
		onError: (error) => {
			toast(
				ToastCustom({
					description: getErrorMessage(error),
					title: "Erro ao baixar arquivo",
					variant: "error",
				})
			);
		},
	});
}
